import { useState } from "react";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/Reveal";
import { KitchenCard } from "../components/KitchenCard";
import { CTABand } from "../components/CTABand";
import { KITCHENS, KITCHEN_CATEGORIES } from "../data/kitchens";

export default function Kitchens() {
  const [filter, setFilter] = useState("All");
  const filtered =
    filter === "All" ? KITCHENS : KITCHENS.filter((k) => k.category === filter);

  return (
    <>
      <SEO
        title="Kitchen Designs Gallery | 20 Modular Kitchen Layouts — Paramount Kitchen"
        description="Explore 20 premium modular kitchen designs — straight, L-shaped, U-shaped, island, parallel, handleless, luxury and Indian functional kitchens, manufactured in Kangra, Himachal Pradesh."
      />

      <section className="bg-royal pb-16 pt-36 text-ivory md:pb-20 md:pt-44">
        <div className="mx-auto max-w-7xl px-6">
          <Reveal>
            <p className="eyebrow text-gold">The Collection</p>
            <h1 className="text-balance mt-5 max-w-3xl font-display text-4xl font-medium leading-tight md:text-6xl">
              Kitchens for every space,
              <span className="serif-accent text-gold"> engineered for every day.</span>
            </h1>
            <p className="mt-5 max-w-2xl text-ivory/65">
              Twenty designs across every major layout and finish — each one built on the same
              engineered carcass, laminated plywood and precision manufacturing.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-6">
          <div
            data-testid="kitchen-filters"
            className="no-scrollbar -mx-6 flex gap-2.5 overflow-x-auto px-6 pb-2"
          >
            {["All", ...KITCHEN_CATEGORIES].map((c) => (
              <button
                key={c}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => setFilter(c)}
                className={`shrink-0 rounded-full border px-5 py-2.5 text-xs font-semibold tracking-wide transition-all duration-300 ${
                  filter === c
                    ? "border-royal bg-royal text-ivory shadow-md"
                    : "border-ink/15 bg-white text-ink/70 hover:border-gold hover:text-ink"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-ink/45">
            Showing {filtered.length} {filtered.length === 1 ? "design" : "designs"}
          </p>

          <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((k, i) => (
              <Reveal key={k.slug} delay={(i % 3) * 0.07}>
                <KitchenCard kitchen={k} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
